module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-right-up-504ae9820ae9693c1efc263169a482d1.svg";